import { List } from "antd";
import { useState } from "react";
import { ListingProperties } from "../../../types/listing.type";
import ListingModal from "../Components/ListingModal";
import { ListingViewItem } from "./interface";
import ListingCard from "./ListingCard";

interface Props {
	items: ListingViewItem[];
}
const ListingListGrid: React.FC<Props> = ({ items }) => {
	const [showDetail, setShowDetail] = useState<ListingProperties | undefined>();

	return (
		<div
			style={{
				maxHeight: 650,
				overflowY: "scroll",
				paddingRight: 5,
				overflowX: "hidden",
			}}
		>
			<List
				grid={{ gutter: 15, xs: 1, md: 2, lg: 3, xl: 4, xxl: 4 }}
				dataSource={items}
				renderItem={(item) => (
					<List.Item>
						<ListingCard
							item={item}
							onShowDetail={() => setShowDetail(item)}
						/>
					</List.Item>
				)}
			/>
			<ListingModal
				open={showDetail !== undefined}
				onClose={() => setShowDetail(undefined)}
				listing={showDetail}
			/>
		</div>
	);
};
export default ListingListGrid;
